// export const getLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (!navigator.geolocation) {
//       // Geolocation is not supported, use a default location (Rajeev Chowk)
//       const pos = {
//         lat: 28.633,
//         lng: 77.2194,
//       };
//       resolve(pos);
//     } else {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const pos = {
//             lat: position.coords.latitude,
//             lng: position.coords.longitude,
//           };
//           resolve(pos);
//         },
//         () => {
//           // If location access is denied, use default location
//           const pos = {
//             lat: 28.633,
//             lng: 77.2194,
//           };
//           resolve(pos);
//         }
//       );
//     }
//   });
// };

// import { DEFAULT_CENTER } from "./config";

// export const getLocation = () => {
// 	return new Promise((resolve, reject) => {
// 		// Check if geolocation is supported
// 		if (navigator.geolocation) {
// 			// Try to get the user's current position
// 			navigator.geolocation.getCurrentPosition(
// 				(position) => {
// 					const latitude = position.coords.latitude;
// 					const longitude = position.coords.longitude;
// 					resolve({ lat: latitude, lng: longitude });
// 				},
// 				(error) => {
// 					console.error(
// 						"Error getting location, using default coordinates:",
// 						error
// 					);
// 					// If there's an error, fallback to default coordinates (Delhi coordinates)
// 					resolve({ lat: DEFAULT_CENTER.lat, lng: DEFAULT_CENTER.lng });
// 				}
// 			);
// 		} else {
// 			console.log("Geolocation is not supported, using default coordinates.");
// 			// Fallback to default coordinates (Delhi coordinates)
// 			resolve({ lat: DEFAULT_CENTER.lat, lng: DEFAULT_CENTER.lng });
// 		}
// 	});
// };

import { DEFAULT_CENTER } from "./config";

export const getLocationFromApi = async () => {
    try {
        const res = await fetch("/api/localize");
        const data = await res.json();
        console.log(data, "asdadsfasf")
        return { lat: data.lat, lng: data.lng };
    } catch (error) {
        console.error("Error fetching location from API:", error);
    
    }
};

export const getLocation = () => {
    return new Promise((resolve, reject) => {
        // Check if geolocation is supported
        if (navigator.geolocation) {
            // Callback to handle success
            const successCallback = (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                resolve({ lat: latitude, lng: longitude });
            };

            // Callback to handle errors
            const errorCallback = (error) => {
                console.error(
                    "Error getting location, using default coordinates:",
                    error
                );
                // Fallback to default coordinates
                resolve({ lat: DEFAULT_CENTER.lat, lng: DEFAULT_CENTER.lng });
            };

            // Prompt the user for their location
            navigator.geolocation.getCurrentPosition(
                successCallback,
                errorCallback
            );
        } else {
            // console.log(
            //     "Geolocation is not supported, using default coordinates."
            // );
            // Fallback to default coordinates
            resolve({ lat: DEFAULT_CENTER.lat, lng: DEFAULT_CENTER.lng });
        }
    });
};
